import React from 'react';
import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export function OiMetricHelp({ title, children }: { title?: string; children: React.ReactNode }) {
  return (
    <Popover
      title={title ?? 'How this is calculated'}
      content={<div style={{ maxWidth: 320, color: 'var(--oi-text-secondary)', fontSize: 13 }}>{children}</div>}
      trigger="click"
    >
      <button
        type="button"
        className="oi-metric-help"
        aria-label={title ?? 'How this is calculated'}
        onClick={(e) => e.stopPropagation()}
      >
        <InfoCircleOutlined />
      </button>
    </Popover>
  );
}
